module.exports = "https://coursera_assets.s3.amazonaws.com/images/6a62c0876c84394e8aeb4a6a392a0708.png";